import { supabase } from "@/integrations/supabase/client";

export async function updateFormSessionProgress(
  sessionId: string,
  currentStep: number,
  currentSubstep: number
): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("form_sessions")
      .update({
        current_step: currentStep,
        current_substep: currentSubstep,
        updated_at: new Date().toISOString(),
      })
      .eq("id", sessionId);

    if (error) {
      console.error("Error updating form session progress:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error updating form session progress:", error);
    return false;
  }
}

export async function updateRiskAnalysisStep(
  sessionId: string,
  step: number
): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("form_sessions")
      .update({
        risk_analysis_current_step: step,
        updated_at: new Date().toISOString(),
      })
      .eq("id", sessionId);

    if (error) {
      console.error("Error updating risk analysis step:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error updating risk analysis step:", error);
    return false;
  }
}

export async function completeFormSession(sessionId: string): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("form_sessions")
      .update({
        status: "completed",
        completed_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      })
      .eq("id", sessionId);

    if (error) {
      console.error("Error completing form session:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error completing form session:", error);
    return false;
  }
}
